import React from 'react'
import { v4 as uuid } from 'uuid'

export type ModalSize = 'sm' | 'md' | 'lg' | 'full' | undefined

export type ModalPayload = {
    id: string
    heading?: React.ReactNode
    content: React.ReactNode
    size?: ModalSize
    onClose?: () => void
}

type ModalListener = (modals: ModalPayload[]) => void

class ModalService {
    private listeners = new Set<ModalListener>()
    private modals: ModalPayload[] = []

    show(modal: Omit<ModalPayload, 'id'>) {
        const id = uuid()
        const payload: ModalPayload = { ...modal, id }
        this.modals.push(payload)
        this.notify()
        return id
    }

    hide(id?: string) {
        if (id) {
            this.modals = this.modals.filter((modal) => modal.id !== id)
        } else {
            this.modals.pop()
        }
        this.notify()
    }

    private notify() {
        this.listeners.forEach((listener) => listener([...this.modals]))
    }

    subscribe(listener: ModalListener) {
        this.listeners.add(listener)
        listener(this.modals)
        return () => this.listeners.delete(listener)
    }
}
const modalService = new ModalService()

const openModal = (modal: Omit<ModalPayload, 'id'>) => {
    return modalService.show(modal)
}

const closeModal = (id?: string) => {
    modalService.hide(id)
}

export { openModal, closeModal, modalService }
